import React from "react";

interface TimelineItemProps {
  logo: string;
  title: string;
  subtitle: string;
  dateRange: string;
  description?: React.ReactNode;
}

const TimelineItem: React.FC<TimelineItemProps> = ({
  logo,
  title,
  subtitle,
  dateRange,
  description,
}) => {
  return (
    <div className="mb-8">
      <div className="flex items-start">
        <div className="w-12 h-12 flex items-center justify-center bg-gray-700 rounded-full mr-3 -ml-12">
          <img src={logo} alt={title} width="48" height="48" className="h-10 w-10 object-contain" />
        </div>

        <div className="flex-1">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="text-md font-semibold">{title}</h3>
              <p className="text-gray-400 text-sm">{subtitle}</p>
            </div>
            <div className="ml-4 w-28 md:w-36 lg:w-44 flex-shrink-0 text-right">
              <p className="text-gray-400 text-sm">{dateRange}</p>
            </div>
          </div>
          {description && <div className="mt-2 text-gray-300 text-sm">{description}</div>}
        </div>
      </div>
    </div>
  );
};

export default TimelineItem;
